/* tslint:disable */
/* eslint-disable */
/**
 * Hermes Console
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 乗務員
 * @export
 * @interface DriversRow
 */
export interface DriversRow {
    /**
     * 乗務員ID
     * @type {number}
     * @memberof DriversRow
     */
    driverId?: number;
    /**
     * 乗務員番号
     * @type {string}
     * @memberof DriversRow
     */
    driverCode?: string;
    /**
     * 乗務員名
     * @type {string}
     * @memberof DriversRow
     */
    driverName?: string;
    /**
     * 営業所ID
     * @type {number}
     * @memberof DriversRow
     */
    officeId?: number;
    /**
     * 営業所名称
     * @type {string}
     * @memberof DriversRow
     */
    officeName?: string;
}

export function DriversRowFromJSON(json: any): DriversRow {
    return DriversRowFromJSONTyped(json, false);
}

export function DriversRowFromJSONTyped(json: any, ignoreDiscriminator: boolean): DriversRow {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'driverId': !exists(json, 'driver_id') ? undefined : json['driver_id'],
        'driverCode': !exists(json, 'driver_code') ? undefined : json['driver_code'],
        'driverName': !exists(json, 'driver_name') ? undefined : json['driver_name'],
        'officeId': !exists(json, 'office_id') ? undefined : json['office_id'],
        'officeName': !exists(json, 'office_name') ? undefined : json['office_name'],
    };
}

export function DriversRowToJSON(value?: DriversRow | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'driver_id': value.driverId,
        'driver_code': value.driverCode,
        'driver_name': value.driverName,
        'office_id': value.officeId,
        'office_name': value.officeName,
    };
}


